import {
  ErrorMapCtx,
  ZodErrorMap,
  ZodIssueCode,
  ZodIssueOptionalMessage,
} from 'zod/v3';

export type MessageFn = (
  issue: ZodIssueOptionalMessage,
  _ctx: ErrorMapCtx,
) => string | undefined;

export type MessageMap = Partial<Record<ZodIssueCode, MessageFn>>;

export const errorMap = (
  message: MessageFn | MessageMap,
): { errorMap: ZodErrorMap } => ({
  errorMap: (issue, _ctx) => ({
    message:
      typeof message === 'function'
        ? message(issue, _ctx) || _ctx.defaultError
        : message[issue.code]?.(issue, _ctx) || _ctx.defaultError,
  }),
});
